import { liveReload } from '@shared/services/realtime.service';
import { canEditFolio, canSignFolio } from '@app/shared/utils/folio-edit';
import { sortCatalog } from '@app/shared/utils/sort.utils';
import { KpiStripComponent, ListKpi } from '@app/shared/components/kpi-strip/kpi-strip.component';
import { SimpleExcelService } from '@app/shared/services/simple-excel.service';
import { ListSelection, ListView } from '@app/shared/utils/list-view';
import { SelectionBarComponent } from '@app/shared/components/selection-bar/selection-bar.component';
import { PageLoaderComponent, PageLoad } from '@app/shared/components/page-loader/page-loader.component';
import { currentMonthStart, currentMonthEnd, inDateRange, parseApiDate } from '@app/shared/utils/date-range';
import { FilterChipsComponent, FilterChip } from '@app/shared/components/filter-bar/filter-chips.component';
import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
import { UserScopeService, UserScope, inScope, restrictToScope } from '@app/shared/services/user-scope.service';
import { inject, APP_INITIALIZER, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModulesService } from '@shared/services/modules.service';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { ProcedureService } from '@app/shared/services/entities/procedure.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
//import { InterventionsPdfService } from '../shared/services/entities/interventions-pdf.service';
import { ProductsService } from '@app/shared/services/entities/products.service';
import { UsersService } from '@app/shared/services/entities/users.service';
import { DoctorsService } from '@app/shared/services/entities/doctors.service';
import { KitService } from '@app/shared/services/entities/kit.service';
import { RolePermissionsService } from '@shared/services/auth/role-permissions.service';
import { SpecialtyService } from '@app/shared/services/entities/specialty.service';
import { PatientsService } from '@app/shared/services/entities/patients.service';
import { OperationRoomsService } from '@app/shared/services/entities/operationRooms.service';
import { PlacesService } from '@app/shared/services/entities/places.service';
import { WarehousesService } from '@app/shared/services/entities/warehouse.service';
import { ContractsService } from '@app/shared/services/entities/contracts.service';
import { SupplierService } from '@app/shared/services/entities/supplier.service';
import { MatTableDataSource } from '@angular/material/table';
import { InterventionsDialogComponent } from './interventions-dialog/interventions-dialog.component';
import { InterventionsDeliveryDialogComponent } from './interventions-delivery-dialog/interventions-delivery-dialog.component';
import { InterventionsRequestDialogComponent } from './interventions-request-dialog/interventions-request-dialog.component';
import { InterventionsConsumptionDialogComponent } from './interventions-consumption-dialog/interventions-consumption-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GaFormsDialogComponent, GaFormsDialogData } from '@app/shared/pdf/ga-forms-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, PageEvent} from '@angular/material/paginator';
import { CancelDialog } from './interventions-cancel-dialog/interventions-cancel-dialog.component';
import { OrderDialog } from './order-dialog/order-dialog.component';
import { NetworkService } from '@app/shared/services/network.service';
import { RemissionsService } from '@app/shared/services/entities/remissions.service';
import { StockService } from '@app/shared/services/entities/stock.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TabService } from '@app/shared/services/tab-check.service';
import { RolesService } from '@app/shared/services/entities/roles.service';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import { SelectCheckAllComponent } from '@app/custom-material/select-check-all/select-check-all.component';
const log = new LoggerService('INTERVENTIONS COMPONENT')

@Component({
  standalone: true,
  imports: [KpiStripComponent, SelectionBarComponent, PageLoaderComponent, SearchPillComponent, FilterChipsComponent, PageTitleComponent, 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SelectCheckAllComponent,
  ],
  selector: 'app-interventions',
  templateUrl: './interventions.component.html',
  styleUrls: ['./interventions.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class InterventionsComponent implements OnInit, OnDestroy {
  private modulesSvcTitle = inject(ModulesService);
  /** Título del módulo = etiqueta visible del catálogo de Módulos. */
  title = this.modulesSvcTitle.moduleTitle('/interventions', 'Salida de material');

  /** Pantalla de Folios o de Remisiones (viene de la ruta). */
  private readonly activatedRoute = inject(ActivatedRoute);
  readonly mode: 'folio' | 'remission' = (this.activatedRoute.snapshot.data?.['mode'] === 'remission') ? 'remission' : 'folio';
  get isRemissionMode(): boolean { return this.mode === 'remission'; }
  /** Título = etiqueta visible del sub-módulo (Folio / Remisión) en Módulos. */
  private readonly folioLabel = this.modulesSvcTitle.moduleTitle('/interventions/folios', 'Folios');
  private readonly remissionLabel = this.modulesSvcTitle.moduleTitle('/interventions/remissions', 'Remisiones');
  get pageTitle(): string { return this.isRemissionMode ? this.remissionLabel() : this.folioLabel(); }
  goToMenu(): void { this.router.navigate(['/interventions']); }

  /** Columnas de la tabla según la pantalla. */
  get displayedColumns(): string[] {
    // Orden pedido: estatus, folio, técnico y después lo demás.
    return this.isRemissionMode
      ? ['select', 'status', 'fileNumber', 'technician', 'hospital', 'doctor', 'createdOn', 'actions']
      : ['select', 'status', 'fileNumber', 'technician', 'hospital', 'intervention', 'program', 'specialty', 'episode', 'doctor', 'patient', 'createdOn', 'actions'];
  }

  /** Vista tabla / tarjetas (se recuerda por pantalla) y selección con checkbox. */
  readonly listView = new ListView(this.mode === 'remission' ? 'remissions' : 'folios', 'table');
  readonly sel = new ListSelection<any>(() => (this.dataSource?.filteredData ?? []) as any[]);
  private readonly simpleExcel = inject(SimpleExcelService);

  // ─── Indicadores (como en el inventario): cuentan sobre TODO lo cargado ───
  kpis: ListKpi[] = [];
  activeKpi: string | null = null;

  private static readonly KPI_FILTERS: Record<string, (r: any) => boolean> = {
    drafts:    r => ['Incompleto', 'Borrador'].includes(r?.status),
    pending:   r => ['Pendiente', 'Permiso', 'Confirmada'].includes(r?.status),
    done:      r => ['Realizada', 'Firmado', 'T. Facturacion', 'Facturado'].includes(r?.status),
    cancelled: r => r?.status === 'Cancelada',
    emitted:   r => ['Emitida', 'Facturada'].includes(r?.status),
    withItems: r => ((r?._remission?.items ?? []) as any[]).length + ((r?._remission?.otherItems ?? []) as any[]).length > 0,
    noItems:   r => ((r?._remission?.items ?? []) as any[]).length + ((r?._remission?.otherItems ?? []) as any[]).length === 0,
    today:     r => new Date(parseApiDate(r?.createdOn)).toDateString() === new Date().toDateString(),
  };

  /** Recalcula los indicadores y vuelve a pintar la lista (con el indicador activo). */
  /** Filtro de hospitales (vacío = todos). */
  public hospitalFilter: string[] = [];

  /** Hospital de un renglón (folio: `hospital`; remisión: `place`). */
  rowHospital(row: any): string | null {
    const id = row?._kind === 'REMISION' ? row?._remission?.place : (row?.hospital?.id ?? row?.hospital);
    return id ? String(id) : null;
  }

  /** Hospitales que se pueden elegir: sitios tipo Hospital dentro del alcance del usuario. */
  get hospitalFilterOptions(): any[] {
    return (this.placesList ?? []).filter((p: any) =>
      p && String(p.type ?? '').toUpperCase() === 'HOSPITAL' && inScope(this.scope?.places ?? null, p.id, false));
  }

  hospitalLabel(id: string): string {
    const p: any = (this.placesList ?? []).find((x: any) => x?.id === id);
    return p?.alias || p?.name || '—';
  }

  onHospitalFilterChange(): void { this.refreshKpis(); }

  private get hospitalFiltered(): any[] {
    const all = (this.interventionList ?? []) as any[];
    if (!this.hospitalFilter?.length) return all;
    const set = new Set(this.hospitalFilter.map(String));
    return all.filter(r => { const h = this.rowHospital(r); return !!h && set.has(h); });
  }

  /** Nombre del técnico del folio/remisión. */
  technicianName(row: any): string {
    const id = row?._kind === 'REMISION' ? row?._remission?.technician : row?.technician;
    return id ? (this.usersObject?.[id] ?? '—') : '—';
  }

  private refreshKpis(): void {
    const all = this.hospitalFiltered;
    const count = (key: string) => all.filter(InterventionsComponent.KPI_FILTERS[key]).length;
    this.kpis = this.isRemissionMode
      ? [
          { key: 'total', label: 'Total de remisiones', icon: 'receipt_long', value: all.length, isTotal: true },
          { key: 'drafts', label: 'Borradores', icon: 'edit_note', value: count('drafts'), tone: 'warn' },
          { key: 'emitted', label: 'Emitidas', icon: 'task_alt', value: count('emitted'), tone: 'ok' },
          { key: 'cancelled', label: 'Canceladas', icon: 'cancel', value: count('cancelled') },
          { key: 'today', label: 'Creadas hoy', icon: 'today', value: count('today'), tone: 'danger' },
        ]
      : [
          { key: 'total', label: 'Total de folios', icon: 'receipt_long', value: all.length, isTotal: true },
          { key: 'drafts', label: 'Borradores', icon: 'edit_note', value: count('drafts'), tone: 'warn' },
          { key: 'pending', label: 'Pendientes', icon: 'schedule', value: count('pending'), tone: 'danger' },
          { key: 'done', label: 'Realizados', icon: 'task_alt', value: count('done'), tone: 'ok' },
          { key: 'cancelled', label: 'Cancelados', icon: 'cancel', value: count('cancelled') },
        ];
    if (this.activeKpi && !this.kpis.some(k => k.key === this.activeKpi)) this.activeKpi = null;
    this.applyKpi();
  }

  setKpi(key: string | null): void {
    this.activeKpi = key;
    this.applyKpi();
  }

  private applyKpi(): void {
    const all = this.hospitalFiltered;
    const f = this.activeKpi ? InterventionsComponent.KPI_FILTERS[this.activeKpi] : null;
    this.dataSource = new MatTableDataSource(f ? all.filter(f) : all);
    this.dataSource.paginator = this.paginator;
    this.length = this.dataSource.filteredData.length;
    this.pagedList = this.dataSource.filteredData.slice(0, 50);
    if (this.searchText) this.setSearch(this.searchText);
  }

  /** Clase de color del estatus (tabla y tarjetas). */
  statusCss(status: string): string {
    return ({
      'Realizada': 'green-status', 'Cancelada': 'red-status', 'Firmado': 'blue-status',
      'Pendiente': 'yellow-status', 'T. Facturacion': 'purple-status', 'Facturado': 'sky-status',
      'Incompleto': 'yellow-status', 'Borrador': 'yellow-status', 'Permiso': 'brown-status',
      'Emitida': 'green-status', 'Facturada': 'sky-status',
    } as Record<string, string>)[status] ?? '';
  }

  /** Exporta a Excel los folios / remisiones seleccionados. */
  exportSelection(): void {
    const rows = this.sel.selected.map((r: any) => ({
      folio: r.fileNumber ?? '',
      status: r.status ?? '',
      procedure: r._kind === 'REMISION' ? 'Remisión' : (this.procedureObject[r.procedure] ?? ''),
      date: r.interventionDatetime ? this.formatDate(r.interventionDatetime) : '',
      hospital: r._hospitalName ?? '',
      specialty: r.specialty ? (this.specialtyObject[r.specialty] ?? '') : '',
      doctor: r.doctor ? (this.doctorObject[r.doctor] ?? '') : (r._doctorName ?? ''),
      patient: r.patient ? (this.patientObject?.[r.patient]?.name ?? '') : '',
      createdOn: r.createdOn ?? '',
    }));
    if (!rows.length) return;
    this.simpleExcel.simpleXLSX({
      fileName: (this.isRemissionMode ? 'Remisiones' : 'Folios') + ' (selección)',
      sheets: [{
        sheetName: 'Selección', header: [], lineBreak: 0, data: rows,
        columns: [
          { columnKey: 'folio', columnName: 'Folio' },
          { columnKey: 'status', columnName: 'Estatus' },
          { columnKey: 'procedure', columnName: 'Procedimiento' },
          { columnKey: 'date', columnName: 'Fecha Cx' },
          { columnKey: 'hospital', columnName: 'Hospital' },
          { columnKey: 'specialty', columnName: 'Especialidad' },
          { columnKey: 'doctor', columnName: 'Médico' },
          { columnKey: 'patient', columnName: 'Paciente' },
          { columnKey: 'createdOn', columnName: 'Fecha de creación' },
        ],
      }],
    } as any);
  }

  /**
  *  Variabels
  */
  isSlowConnection = false; //Validar conexión de red
  private sub?: Subscription; //Validar pestañas múltiples

  viewType = 'Cards'

  public formGroup: FormGroup = this.formBuilder.group({
    startDate: [null],
    finishDate: [null],
    doctor: [null],
    procedure: [null],
    specialty: [null],
    status: [null],
    start: null
  });

  dateRangeForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  startDate: any;
  endDate: any

  public createBtn = false;

  public contractList: any[] = [];
  public contractObject: { [key: string]: any } = {};

  public equipmentList: any[] = [];
  public equipmentObject: { [key: string]: any } = {};

  public hospitalList: any[] = [];
  public hospitalObject: { [key: string]: any } = {};

  public interventionList: any[] = [];

  public medicalSupplySpecialistList: any[] = [];
  public medicalSupplySpecialistObject: { [key: string]: any } = {};

  public operationRoomList: any[] = [];
  public operationRoomObject: { [key: string]: any } = {};

  public patientList: any[] = [];
  public patientObject: { [key: string]: any } = {};

  public placesList: any[] = [];
  public placesObject: { [key: string]: any } = {};

  public kitList: any[] = [];
  public kitObject: { [key: string]: any } = {};

  public productList: any[] = [];
  public productObject: { [key: string]: any } = {};

  public productSelected = [];

  public substitutesObject: { [key: string]: any } = {};
  public substitutesList: any[] = [];

  public supplierList: any[] = [];
  public supplierObject: { [key: string]: any } = {};

  public technicalSpecialistList: any[] = [];
  public technicalSpecialistObject: { [key: string]: any } = {};

  public usersList: any[] = [];
  public usersObject: { [key: string]: any } = {};

  public warehousesList: any[] = [];
  public warehousesObject: { [key: string]: any } = {};
  
  public roleList: any[] = [];
  public operationRoleList = ['Director Operaciones','Subdirector Operaciones','Gerente Técnico Médico','Gerente Administrativo','Supervisor Administrativo','Coordinador Administrativo','Gestor Administrativo','Supervisor Especialista de Abasto Médico','Coordinador Especialista de Abasto Médico','Especialista de Abasto Médico','Supervisor Técnico Medico','Coordinador Técnico Medico','Técnico Especialista',"Técnico Especialista - Gestor Administrativo","Especialista de Abasto Médico - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo",'Gerente','Compras','Especialista','Finanzas'];
  public tecnicoRoleList = ['Supervisor Técnico Medico','Coordinador Técnico Medico','Técnico Especialista',"Técnico Especialista - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo",'Gerente'];
  public almacenistaRoleList = ['Supervisor Especialista de Abasto Médico','Coordinador Especialista de Abasto Médico','Especialista de Abasto Médico',"Especialista de Abasto Médico - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo"];

    //doctor
    public doctorControl = new FormControl<any>('');
    public doctorList: any[] = [];
    public doctorObject: { [key: string]: any } = {};
    public doctorOptions: any[] = [];
    public doctor = null;
    @ViewChild('doctorSelect') doctorSelect;
    //Procedure
    public procedureControl = new FormControl<any>('');
    public procedureOptions: any[] = [];
    public procedureList: any[] = [];
    public procedureObject: { [key: string]: any } = {};
    public procedure = null;
    @ViewChild('procedureSelect') procedureSelect;
    //Specialty
    public specialtyControl = new FormControl<any>('');
    public specialtyList: any[] = [];
    public specialtyObject: { [key: string]: any } = {};
    public specialtyOptions: any[] = [];
    public specialty = null;
    @ViewChild('specialtySelect') specialtySelect;
    //status
    public statusControl = new FormControl<any>('');
    public statusList = ['Incompleto','Borrador','Pendiente','Permiso','Realizada','Cancelada'];
    public statusObject: { [key: string]: any } = {};
    public statussObj: any[] = [];
    public statusOptions = ['Incompleto','Borrador','Pendiente','Permiso','Realizada','Cancelada'];
    public status = null;
    @ViewChild('statusSelect') statusSelect;

  public dataSource = new MatTableDataSource<any>([]);
  public isTecnico = false;
  public customParams: { [key: string]: any } = {};
  /** Hospitales/especialidades asignados al usuario (null = ve todo). */
  public scope: UserScope = { places: null, specialties: null };
  private userScopeService = inject(UserScopeService);
  public permissions: { [key: string]: any } = {};


   //Paginación
  length: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10,50, 100];
  pagedList: any[] = [];
  pageEvent!: PageEvent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private procedureService: ProcedureService,
    private doctorsService: DoctorsService,
    private patientsService: PatientsService,
    private kitService: KitService,
    private productsService: ProductsService,
    private operationRoomService: OperationRoomsService,
    private placesService: PlacesService,
    private warehousesService: WarehousesService,
    private contractsService: ContractsService,
    private permissionsService: RolePermissionsService,
    private specialtyService: SpecialtyService,
    private supplierService: SupplierService,
    private usersService: UsersService,
    private interventionsService: InterventionsService,
    //private interventionsPdfService: InterventionsPdfService,
    private customMessageService: CustomMessageService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private networkService: NetworkService,
    private tabWatcher: TabService,
    private roleService: RolesService,
    private router: Router,
    private remissionsService: RemissionsService,
    private stockService: StockService,
  ) { }

  /** Asistente de 5 pasos: alta nueva o reanudar un borrador. */
  /** Folio Realizado o Cancelado: ya no se continúa ni se cancela. Tampoco
   *  si el usuario no puede modificarlo (técnico: solo los suyos y dentro de su
   *  turno; coordinador y admin: todos). Ver shared/utils/folio-edit.ts. */
  isClosedFolio(row: any): boolean {
    if (['Realizada', 'Firmado', 'T. Facturacion', 'Facturado', 'Cancelada'].includes(String(row?.status ?? ''))) return true;
    return !canEditFolio(row, sessionStorage.getItem('userId'), this.customParams?.roles ?? null);
  }

  /** Formato GA "BITACORA PREFERENCIA MÉDICA", calculado de los folios del médico. */
  openDoctorPreference(): void {
    const data: GaFormsDialogData = { mode: 'preference', scopePlaces: this.scope.places };
    this.dialog.open(GaFormsDialogComponent, { data, width: '620px', maxWidth: '95vw', autoFocus: false });
  }

  /** Folio Pendiente de un técnico fuera de su turno: solo puede subir el vale firmado. */
  canSignOnly(row: any): boolean {
    return this.isClosedFolio(row)
      && canSignFolio(row, sessionStorage.getItem('userId'), this.customParams?.roles ?? null);
  }

  goToSign(record: any): void {
    if (record?.id && this.canSignOnly(record)) this.router.navigate(['/interventions/wizard', record.id]);
  }

  goToWizard(record?: any) {
    if (record && this.isClosedFolio(record)) return;
    if (record?.id) this.router.navigate(['/interventions/wizard', record.id]);
    else this.router.navigate(['/interventions/wizard']);
  }

  /** Segunda ruta de salida de material: remisión directa (con o sin folio). */
  goToRemission(record?: any): void {
    // Proceso de captura con pasos dentro de Salida de material (nada de tablas).
    if (record?.id) this.router.navigate(['/interventions/remission', record.id]);
    else this.router.navigate(['/interventions/remission']);
  }

  /** Borradores de remisión pendientes (se retoman desde esta lista). */
  public remissionDrafts: any[] = [];

  async loadRemissionDrafts(): Promise<void> {
    try {
      const response = await this.remissionsService.search({
        // Todas las remisiones (borradores, emitidas, facturadas y canceladas); el
        // estatus se ve en la tabla y en los indicadores.
        searchType: 'default', condition: { deleted: false },
      });
      this.remissionDrafts = ((response.data as any[]) ?? []).filter(x => x)
        .sort((a, b) => String(b.createdOn ?? '').localeCompare(String(a.createdOn ?? '')));
    } catch (err) {
      log.error('[loadRemissionDrafts]', err);
      this.remissionDrafts = [];
    }
  }

  /** Pantalla de Remisiones: la tabla son los borradores de remisión. */
  async getRemissionRows(): Promise<void> {
    await this.loadRemissionDrafts();
    const rows = this.remissionDrafts
      .filter(rem => inScope(this.scope.places, rem?.place))
      .filter(rem => this.inPeriod(rem?.createdOn))
      .map(rem => ({
        _kind: 'REMISION',
        _remission: rem,
        id: rem.id,
        fileNumber: rem.folio,
        status: rem.status ?? 'Incompleto',
        interventionDatetime: rem.createdOn,
        createdOn: rem.createdOn,
        episode: null, specialty: null, procedure: null, patient: null, doctor: null,
        _hospitalName: this.remissionPlaceName(rem.place),
        _procedureName: 'Remisión',
        _specialtyName: '',
        _doctorName: rem.doctorName ?? '',
      }));
    this.interventionList = rows.filter(r => this.remissionMatchesFilters(r._remission));
    this.refreshKpis();
  }

  /** Filtros de "Más filtros" sobre una remisión (por nombre de médico / Cx). */
  private remissionMatchesFilters(rem: any): boolean {
    const norm = (v: any) => String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();
    const picked = (control: any, options: any[]): any[] | null => {
      const value: any[] = Array.isArray(control?.value) ? control.value : [];
      return !options?.length || options.every(o => value.includes(o)) ? null : value;
    };
    const doctor = this.doctorList.find((d: any) => norm(d?.name) === norm(rem?.doctorName));
    const docs = picked(this.doctorControl, this.doctorOptions);
    if (docs && !(doctor && docs.includes(doctor.id))) return false;
    const specs = picked(this.specialtyControl, this.specialtyOptions);
    if (specs) {
      const ds: any[] = doctor ? (Array.isArray(doctor.specialty) ? doctor.specialty : (Array.isArray(doctor.specialties) ? doctor.specialties : [doctor.specialty])) : [];
      if (!ds.some(x => specs.includes(x))) return false;
    }
    const procs = picked(this.procedureControl, this.procedureOptions);
    if (procs) {
      const names = new Set(procs.map(id => norm(this.procedureObject?.[id])));
      if (!names.has(norm(rem?.procedureName))) return false;
    }
    return true;
  }

  /** ¿La remisión sigue en borrador (se puede continuar / emitir)? */
  isRemissionDraft(row: any): boolean {
    return ['Incompleto', 'Borrador'].includes(row?._remission?.status ?? row?.status);
  }

  remissionPlaceName(id: string): string {
    const p: any = this.placesList.find((x: any) => x?.id === id);
    return p?.alias || p?.name || '—';
  }

  async emitRemission(remission: any): Promise<void> {
    const confirmed = await this.customMessageService.open({
      title: 'Cuidado', type: 'warning',
      message: `¿Emitir la remisión <b>${remission.folio}</b>?`,
      dismissBtn: true, acceptBtn: true,
    });
    if (!confirmed) return;
    try {
      await this.remissionsService.update({ id: remission.id, status: 'Emitida' });
      await this.getInterventions();
    } catch (err) {
      await this.customMessageService.open({ title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }

  async cancelRemission(remission: any): Promise<void> {
    const confirmed = await this.customMessageService.open({
      title: 'Cuidado', type: 'warning',
      message: `¿Cancelar la remisión <b>${remission.folio}</b>?`,
      dismissBtn: true, acceptBtn: true,
    });
    if (!confirmed) return;
    try {
      // Las piezas apartadas por la remisión regresan a Disponible.
      const stockIds = ((remission.items as any[]) ?? []).filter(i => i?.stock);
      if (stockIds.length > 0) {
        await this.stockService.update({
          operationType: 'multiple',
          records: stockIds.map(i => ({ id: i.stock, tagRfid: i.tagRfid ?? null, status: 'Disponible' })),
        });
      }
      await this.remissionsService.update({ id: remission.id, status: 'Cancelada' });
      await this.getInterventions();
    } catch (err) {
      await this.customMessageService.open({ title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }

  /** Pantalla de carga del módulo: bloquea hasta terminar la carga inicial. */
  readonly pageLoad = new PageLoad();
  /** Tiempo real: recarga cuando otro usuario cambia estos módulos (WebSocket). */
  private readonly live = liveReload(['interventions', 'remissions'], () => this.pageLoad.ready && this.pageLoad.refresh(this.getInterventions()));

  ngOnInit(): void {
    //Validar si otra pestaña está abierta
    this.sub = this.tabWatcher.watchSamePage().subscribe(event => {
      if (event === 'open') {
        this.customMessageService.open({title: 'Advertencia', type: 'error', message: 'Este módulo está abierto en múltiples pestañas. Para garantizar la funcionalidad del sistema, por favor cierre las demás pestañas y espere 5 segundos.', loading:true});
      } else if (event === 'close') {
        this.customMessageService.close()
      }
    });
    void this.init();
  }

  /** Carga inicial (también la usa "Reintentar"). */
  init(): Promise<boolean> {
    return this.pageLoad.run(() => this.initialLoad());
  }

  private async initialLoad(): Promise<void> {
    let apiRoleList: any = await this.roleService.getAllRols();
    this.roleList = apiRoleList.data.map(role => role.name);
    log.debug('[ngOnInit] roleList',this.roleList)
    // Obtener la fecha de hoy
    const firstDate = this.getFirstDayOfYear();
    //log.debug(firstDate)
    const firstFormatted = this.formatDateForForm(firstDate);
    //log.debug(firstFormatted)
    // Obtener la fecha de hoy
    const lastDate = this.getLastDayOfYear();
    const lastFormatted = this.formatDateForForm(lastDate);
    // Inicializar startDate y endDate con la fecha de hoy
    this.startDate = firstFormatted;
    this.endDate = lastFormatted;

    this.formGroup = this.formBuilder.group({
      startDate: [firstFormatted],
      // Fin de día: incluye las cirugías del último día del periodo.
      finishDate: [`${lastFormatted}T23:59:59`],
      doctor: [null],
      procedure: [null],
      specialty: [null],
      status:[null],
      start: null
    });

    // Configurar dateRangeForm con fechas iniciales
    this.dateRangeForm = new FormGroup({
      start: new FormControl(firstDate),  // Fecha de hoy como objeto Date
      end: new FormControl(lastDate)     // Fecha de hoy como objeto Date
    });

    this.dateRangeForm.enable();
    this.statusControl = new FormControl(this.statusOptions);

    this.customMessageService.open({
      type: 'success',
      message: 'Cargando...', 
      title: 'Cargando datos',
      loading: true,
    });
    try{
      //Validar el estado de la conexión
      this.networkService.isConnectionSlow$.subscribe(slow => {
        this.isSlowConnection = slow;
      });
      await this.getRolNameByUserId();
      await this.getEntityDataSpecialties();
      await this.getEntityDataContract(),
      // Cargar todos los datos necesarios
      await Promise.all([
        await this.getEntityDataProcedureCatlog(),
        await this.getEntityDataKits(),
        await this.getEntityDataProducts(),
        await this.getEntityDataWarehouses(),
        await this.getEntityDataPlaces(),
        await this.getEntityDataOperationRoom(),
        await this.getEntityDataDoctors(),
        await this.getEntityDataPatients(),
        await this.getEntityDataSuppliers(),
        await this.getEntityDataUsers(),
      ]);

      await this.getInterventions();

      }catch (error) {
        // La pantalla de carga muestra el error con "Reintentar".
        throw new Error('Error al cargar los datos iniciales: ' + error);
      } finally {
        this.customMessageService.close();
      }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.tabWatcher.stopWatching();
  }

  changeView(view){
    this.viewType = view;
  }

    /*** @description Búsqueda de texto en la tabla */
    public searchText = '';
    public showMoreFilters = false;

    applyFilter(event: Event) {
      this.setSearch((event.target as HTMLInputElement).value);
    }

    setSearch(raw: string) {
      this.searchText = raw ?? '';
      const filterValue = this.searchText
        .replace(/&|<|>|"|'/g, match => ({'&': '&amp;','<': '&lt;','>': '&gt;','"': '&quot;',"'": '&#39;'}[match]!)) //Sanitizar caracteres especiales en HTML
        .replace(/[^a-zA-Z0-9áéíóúñÁÉÍÓÚÑ\-\s]/g, '')      // Solo permitir caracteres alfanuméricos y espacios
        .trim();
      if (!this.dataSource) return;
      this.dataSource.filter = filterValue.toLowerCase();
      this.dataSource.paginator = this.paginator;
      this.length = this.dataSource.filteredData.length;
      this.pagedList = this.dataSource.filteredData.slice(0, 50);
    }

    /** Filtros activos (los que no tienen "todos" seleccionados), como chips. */
    get activeFilterChips(): { key: string; label: string; value: string }[] {
      const chips: { key: string; label: string; value: string }[] = [];
      const add = (key: string, label: string, control: FormControl, options: any[], names: { [k: string]: any }) => {
        const value: any[] = Array.isArray(control?.value) ? control.value : [];
        const all = (options ?? []).map((o: any) => (o && typeof o === 'object') ? o.id : o);
        if (all.length === 0 || all.every(o => value.includes(o))) return;
        const first = value.length ? (names?.[value[0]] ?? value[0]) : 'Ninguno';
        chips.push({ key, label, value: value.length > 1 ? `${first} +${value.length - 1}` : String(first) });
      };
      add('doctor', 'Médico', this.doctorControl, this.doctorOptions, this.doctorObject);
      add('specialty', 'Especialidad', this.specialtyControl, this.specialtyOptions, this.specialtyObject);
      add('procedure', 'Procedimiento', this.procedureControl, this.procedureOptions, this.procedureObject);
      return chips;
    }

    async removeFilter(key: string) {
      if (key === 'specialty') {
        this.specialtyControl.setValue([...this.specialtyOptions]);
        this.specialty = null;
        await this.getProcedureDinamic();
      } else if (key === 'procedure') {
        this.procedureControl.setValue([...this.procedureOptions]);
      } else if (key === 'doctor') {
        this.doctorControl.setValue([...this.doctorOptions]);
      }
      await this.getInterventions();
    }

    async clearAllFilters() {
      this.setSearch('');
      this.hospitalFilter = [];
      {
        this.specialtyControl.setValue([...this.specialtyOptions]);
        this.procedureOptions = this.procedureList.filter(el => this.specialtyOptions.includes(el['specialty'])).map(el => el.id);
        this.procedureControl = new FormControl(this.procedureOptions);
        this.doctorControl = new FormControl([...this.doctorOptions]);
        const first = this.getFirstDayOfYear();
        const last = this.getLastDayOfYear();
        this.dateRangeForm.setValue({ start: first, end: last } as any);
        this.startDate = this.formatDateForForm(first);
        this.endDate = this.formatDateForForm(last);
        this.syncDateFilter();
      }
      await this.getInterventions();
    }

    /** Paginador. */
  OnPageChange(event: PageEvent) {
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.length) {
      endIndex = this.length;
    }
    this.pagedList = this.dataSource.filteredData.slice(startIndex, endIndex);
    //log.debug('[OnPageChange] pagedList', this.pagedList)
    return event;
  }

  /* ************************************ Get Data ***************************************************** */

  /**
   * @description Busca las intervenciones pendientes
   */

  async getInterventions(){
    if (this.isRemissionMode) { await this.getRemissionRows(); return; }
    try {
      let options = this.formGroup.value;
      options['specialty'] = this.specialtyControl.value
      options['procedure'] = this.procedureControl.value
      options['doctor'] = this.doctorControl.value
      // Se cargan TODOS los estatus (también Realizada y Cancelada); el
      // estatus se ve en la tabla y se filtra con los indicadores.
      delete options['status'];
      // Catálogo vacío (p. ej. el usuario no tiene especialidades activas en su
      // alcance): no se filtra por ese campo, en vez de no traer ningún folio.
      if (!this.specialtyOptions?.length) delete options['specialty'];
      if (!this.procedureOptions?.length) delete options['procedure'];
      if (!this.doctorOptions?.length) delete options['doctor'];
      options['start'] = 0;
      options['deleted'] = false;

      log.debug('options',options)
      this.interventionList = [];
      this.dataSource = new MatTableDataSource(this.interventionList);
      this.length = this.dataSource.filteredData.length;
      this.pagedList = this.dataSource.filteredData.slice(0, 50);
      this.dataSource.paginator = this.paginator;
      let apiResponse = await this.interventionsService.search({searchType:'default',condition:options})
      log.debug('[getInterventions] apiResponse', apiResponse)
      if(apiResponse['data'][0] !== null){
        this.interventionList = apiResponse['data'];
        this.interventionList.forEach(intv => {
          intv['_hospitalName'] = this.hospitalLabel(intv.hospital?.id ?? intv.hospital);
          intv['_procedureName'] = this.procedureObject[intv.procedure];
          intv['_specialtyName'] = this.specialtyObject[intv.specialty];
        })
        this.interventionList.sort((a, b) => {
          const dateDiff = Date.parse(a.interventionDatetime) - Date.parse(b.interventionDatetime);
          if (dateDiff !== 0) {
            return dateDiff;
          }
          return String(a._specialtyName ?? '').localeCompare(String(b._specialtyName ?? ''));
        });
      }else{
        this.customMessageService.open({title: 'Información',type: 'neutral',message: 'No se encontraron programaciones quirurgicas.',duration: 3000});
      }

      const statusFilter: any = this.statusControl.value;
      const showDrafts = !Array.isArray(statusFilter) || statusFilter.length === 0 || statusFilter.includes('Incompleto');

      // Borradores de folio (Incompleto/Borrador): se buscan APARTE, sin los
      // filtros de especialidad/procedimiento/médico ni de fechas. Un borrador
      // guardado a medias no tiene esos datos, y `specialty IN (...)` lo dejaba
      // fuera de la tabla y de las tarjetas aunque sí estuviera guardado.
      if (showDrafts) {
        try {
          const draftsResponse: any = await this.interventionsService.search({
            searchType: 'default',
            condition: { deleted: false, status: ['Incompleto', 'Borrador'] },
          });
          const seen = new Set(this.interventionList.map((x: any) => x?.id));
          const drafts = ((draftsResponse?.data as any[]) ?? [])
            .filter(x => x && !seen.has(x.id))
            .filter(x => this.inPeriod(x.interventionDatetime || x.createdOn))
            .map(intv => ({
              ...intv,
              _hospitalName: this.hospitalLabel(intv.hospital?.id ?? intv.hospital),
              _procedureName: this.procedureObject[intv.procedure],
              _specialtyName: this.specialtyObject[intv.specialty],
            }));
          this.interventionList = [...drafts, ...this.interventionList.filter((x: any) => x)];
        } catch (err) {
          log.error('[getInterventions] borradores', err);
        }
      }

      // Las remisiones tienen su propia pantalla (Salida de material → Remisión).

      // Alcance del usuario (Usuarios → Parámetros): solo sus hospitales y
      // especialidades. Sin asignación (null) no se filtra nada.
      this.interventionList = this.interventionList.filter((row: any) => {
        if (!row) return false;
        if (row._kind === 'REMISION') return inScope(this.scope.places, row._remission?.place);
        const hospitalId = row.hospital?.id ?? row.hospital;
        return inScope(this.scope.places, hospitalId) && inScope(this.scope.specialties, row.specialty);
      });

      this.refreshKpis();
    } catch (err) {
      await this.customMessageService.open({title: 'Error', type: 'error',message: String(err),dismissBtn: true});
    }
  }

  /**
   * @description Da formato a fecha
   * @param dateString 
   * @returns 
   */
  public formatDate(dateString:string): string {
    const testDate = new Date(dateString);
    return testDate.toLocaleDateString('es-ES', { day:'2-digit', month:'long', year:'numeric', hour:'numeric', minute:'numeric'})
  }
    /**
   * @description Get item form array
   */
  async getEntityDataContract(){
    try{
      let apiResponse = await this.contractsService.search({searchType:'default',condition:{deleted:false}})
      log.debug('[getEntityDataContract] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.contractList = apiResponse.data;
        this.contractList = this.applyAlphabeticSorting(this.contractList,'name')
        this.contractObject = this.contractList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      } else {
        throw new Error(apiResponse.message);
      }
    }catch(err){
      throw err;
    }
  }


  /**
   * @description Busca catálogo de procedimientos
   */
  private async getEntityDataProcedureCatlog() {
    try{
      let apiResponse = await this.procedureService.search({searchType:'default',condition:{deleted:false, active: true}});
      log.debug('[getEntityDataProcedureCatlog] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.procedureList = apiResponse.data;
        this.procedureList = this.applyAlphabeticSorting(this.procedureList,'name')
        this.procedureOptions= this.procedureList.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).map(element => element.id)
        this.procedureObject = this.procedureList.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
        this.procedureControl = new FormControl(this.procedureOptions);
      } else {
        throw new Error(apiResponse.message);
      }
    }catch (err){
      throw err;
    }
  }

  /**
   * @description Get all specialties
   */
   async getEntityDataSpecialties() {
    try{
      let apiResponse = await this.specialtyService.search({searchType:'default',condition:{deleted:false,active: true}});
      log.debug('[getEntityDataSpecialties] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.specialtyList = restrictToScope(apiResponse.data ?? [], this.scope.specialties);
        this.specialtyList = this.applyAlphabeticSorting(this.specialtyList,'name')
        this.specialtyOptions = this.specialtyList.map(element => element.id)
        this.specialtyObject = this.specialtyList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
        this.specialtyControl = new FormControl(this.specialtyOptions);
      } else {
        throw new Error(apiResponse.message);
    }
    }catch(err){
      throw err;
    }
  }

  /**
   * @description Busca todos los doctores existentes en HitecMI
   */
  private async getEntityDataDoctors() {
    try{
      let apiResponse = await this.doctorsService.search({searchType:'default',condition:{deleted:false, active: true}});
      log.debug('[getEntityDataDoctors] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.doctorList = apiResponse.data;
        this.doctorList = this.applyAlphabeticSorting(this.doctorList,'name')
        this.doctorOptions = this.doctorList.map(element => element.id)//.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).map(element => element.id)
        this.doctorObject = this.doctorList.reduce(function (r, a) {//.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
        this.doctorControl = new FormControl(this.doctorOptions);
      } else {
        throw new Error(apiResponse.message);
      }
    }catch(err){
      throw err;
    }
  }

    /**
   * @description Busca todos los proveedores
   */
    private async getEntityDataPatients() {
      try{
      let apiResponse = await this.patientsService.search({searchType:'default',condition:{deleted:false}});
      log.debug('[getEntityDataPatients] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.patientList = apiResponse.data;
        this.patientList = this.applyAlphabeticSorting(this.patientList,'name')
        this.patientObject = this.patientList.reduce((r, a) => {
          r[a.id] = {
            name: a.name,
            gender: a.gender,
            identifier: a.identifier,
            CURP: a.CURP,
            birthDate: a.birthDate
          };
          return r;
        }, {});
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
    }

        /**
   * @description Busca todos los proveedores
   */
    private async getEntityDataSuppliers() {
      try{
      let apiResponse = await this.supplierService.search({searchType:'default',condition:{deleted:false, active: true}});
      log.debug('[getEntityDataSuppliers] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.supplierList = apiResponse.data;
        this.supplierList = this.applyAlphabeticSorting(this.supplierList,'name')
        this.supplierObject = this.supplierList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
    }


    
  /**
   * @description Busca todos los usuarios existentes en HitecMI
   */
    private async getEntityDataUsers() {
      try{
      let apiResponse = await this.usersService.getUsers(this.roleList);
      log.debug('[getEntityDataUsers] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.usersList = apiResponse.data;
        this.usersList = this.applyAlphabeticSorting(this.usersList,'name')
        this.usersObject = this.usersList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
    }

    /**
   * @description Get all products
   */
   private async getEntityDataKits() {
    try{
    let apiResponse = await this.kitService.search({searchType:'default',condition:{deleted:false, active: true}});
    //log.debug('[getEntityDataPorducts] apiResponse', apiResponse)
    if (apiResponse.state === 'success') {
      this.kitList = apiResponse.data;
      this.kitList = this.applyAlphabeticSorting(this.kitList,'name')
      this.kitObject = this.kitList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
    } else {
      throw new Error(apiResponse.message);
    }
    }catch(err){
      throw err;
    }
  }
    
        
  /**
   * @description Get all products
   */
   private async getEntityDataProducts() {
    try{
    let apiResponse = await this.productsService.search({searchType:'default',condition:{deleted:false, active: true}});
    //log.debug('[getEntityDataPorducts] apiResponse', apiResponse)
    if (apiResponse.state === 'success') {
      this.productList = apiResponse.data;
      this.productList = this.applyAlphabeticSorting(this.productList,'code')
      this.productObject = this.productList.reduce((r, a) => {
        r[a['id']] = {
          'code': a['code'], 
          'description': a['description'], 
          'usageFactor': a['usageFactor'],
          'itemNumber': this.contractList.length > 0 
            ? a['itemNumbers']?.[this.contractList[0]['id']] ?? null
            : null
        };
        return r;
      }, Object.create(null));
    
    } else {
      throw new Error(apiResponse.message);
    }
    }catch(err){
      throw err;
    }
  }

    /**
   * @description Get all places
   */
    async getEntityDataOperationRoom() {
      try{
      let apiResponse = await this.operationRoomService.search({searchType:'default',condition:{deleted:false, active: true}});
      if (apiResponse.state === 'success') {
        this.operationRoomList = apiResponse.data;
        this.operationRoomList = this.applyAlphabeticSorting(this.operationRoomList,'name')
        this.operationRoomObject = this.operationRoomList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
    }

        /**
   * @description Get all places
   */
    async getEntityDataPlaces() {
      try{
      let apiResponse = await this.placesService.search({searchType:'default',condition:{deleted:false, active: true}});
      if (apiResponse.state === 'success') {
        this.placesList = apiResponse.data;
        this.placesList = this.applyAlphabeticSorting(this.placesList,'name')
        this.placesObject = this.placesList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
    }

  /**
   * @description Get all warehouses
   */
  async getEntityDataWarehouses() {
    try{
    let apiResponse = await this.warehousesService.search({searchType:'default',condition:{deleted:false, active: true}});
    if (apiResponse.state === 'success') {
      this.warehousesList = apiResponse.data;
      this.warehousesList = this.applyAlphabeticSorting(this.warehousesList,'name')
      this.warehousesObject = this.warehousesList.reduce(function (r, a) {
        r[a['id']] = r[a['id']] || [];
        r[a['id']] = a['name'];
        return r;
      }, Object.create(null));
    
    } else {
      throw new Error(apiResponse.message);
    }
    }catch(err){
      throw err;
    }
  }

  // Obtiene el primer día del año actual (1 de enero)
// Periodo por omisión: primer día del MES ACTUAL (se amplía con el filtro).
private getFirstDayOfYear(): Date  {
  return currentMonthStart();
}


// Obtiene el último día del año actual (31 de diciembre)
// Periodo por omisión: último día del MES ACTUAL.
private getLastDayOfYear(): Date {
  return currentMonthEnd();
}

/** ¿El registro cae en el periodo elegido en el filtro? */
private inPeriod(value: any): boolean {
  const v: any = this.dateRangeForm?.value ?? {};
  return inDateRange(value, v.start, v.end, true);
}

  private formatDateForForm(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Cambio de fechas del filtro "Periodo". Filtra por FECHA DE CX
   * (interventionDatetime, así lo hace el API). Al completar el rango
   * (inicio y fin) se vuelve a buscar solo, sin tener que dar "Aplicar".
   * El fin se manda como fin de día para incluir las cirugías de ese día.
   */
  onDateChange(event: any, type: string) {
    const d: Date | null = event?.value instanceof Date && !isNaN(event.value.getTime()) ? event.value : null;
    const fmt = (x: Date) => `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
    if (type === 'start') this.startDate = d ? fmt(d) : null;
    if (type === 'end') this.endDate = d ? fmt(d) : null;
    this.syncDateFilter();
    if (type === 'end' && this.startDate && this.endDate) void this.pageLoad.refresh(this.getInterventions());
  }

  /** Pasa el periodo elegido a la condición de búsqueda (startDate / finishDate). */
  private syncDateFilter(): void {
    this.formGroup.patchValue({
      startDate: this.startDate || null,
      finishDate: this.endDate ? `${this.endDate}T23:59:59` : null,
    }, { emitEvent: false });
  }


  async change(){
    this.customMessageService.open({ title: "Espere",type: 'success', message: 'Generando cambios...', loading: true, duration: 1500 });
    await this.getProcedureDinamic();
    await this.getDoctorDinamic();
  }

  async getProcedureDinamic(){
    this.customMessageService.open({ title: "Espere",type: 'success', message: 'Obteniendo procedimientos...', loading: true, duration: 1500 });
    this.procedureOptions = this.procedureList.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).map(element => element.id)
    this.procedureControl = new FormControl(this.procedureOptions);
  }

    async getDoctorDinamic(){
    this.customMessageService.open({ title: "Espere",type: 'success', message: 'Obteniendo procedimientos...', loading: true, duration: 1500 });
    this.doctorOptions = this.doctorList.map(element => element.id)//.filter(element =>   this.specialtyControl.value.includes(element['specialty'])).map(element => element.id)
    this.doctorControl = new FormControl(this.doctorOptions);
  }

  /* ************************************ Interface ***************************************************** */

    /**@description Cambio de status de intervención */
    async changeInterventionStatus(record: any, index: number, status: String){
      //log.debug(record)
      const deleteConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres cambiar el estatus a <b>${status}</b> el folio <b>${record.fileNumber} | ${this.procedureObject[record.procedure]}</b>. Paciente <b>${record.patientName}</b> de forma permanente?`,
        acceptBtn: true,
        dismissBtn: true,
      });
  
      if (!deleteConfirm) return;
      let data = {};
      data['id'] = record['id'];
      if (status == 'Cancelada'){
        data['status'] = 'Cancelada';
      }
      else if(status == 'Pendiente') {
        data['status'] = 'Pendiente';
      }
      else if(status == 'Eliminada'){
        data['deleted'] = true;
      }
      let response = await this.pacthInterventions(data);
      if(response) this.getInterventions()
    }

    /**
   * @description Edición de intervención
   */
    async pacthInterventions(data: any) {
      this.customMessageService.open({
        title: 'Espere',
        type: 'neutral',
        message: 'Actualizando programación quirúrgica',
        duration: 2000,
        loading: true,
      });
      data['operationType']= 'single'
      let apiResponse = await this.interventionsService.update(data);
      //log.debug(apiResponse);
      if (apiResponse['state'] == 'success') {
        await this.customMessageService.open({
          title: '¡Hecho!',
          type: 'success',
          message: apiResponse['message'],
          duration: 2000,
        });
        return apiResponse.data[0];
      } else {
        await this.customMessageService.open({
          title: 'Error',
          type: 'error',
          message: apiResponse['message'],
          duration: 2000,
        });
      }
    }

async getRolNameByUserId() {
  try {
    const userId = sessionStorage.getItem('userId');
    const apiResponse: any = await this.usersService.getRolNameByUserId({ id: userId });

    const data = apiResponse?.data;

    if (!Array.isArray(data) || data.length === 0) {
      throw new Error('El usuario no tiene roles ni parámetros asignados');
    }

    this.customParams = data[0];
    this.scope = this.userScopeService.fromContext(data[0]);

    // Seguridad extra
    this.customParams.specialty ??= [];
    this.customParams.place ??= [];
    this.customParams.warehouse ??= [];

    this.permissions = await this.permissionsService.forRoute('/interventions');

  } catch (err) {
    console.error('[getRolNameByUserId]', err);
    throw err;
  }
}

  /* ************************************ Dialogs ***************************************************** */

    /**
   * @description Ventana de dialogo para creación y edición 
   */
    openInterventionDialog(type: String, record?: any, index?: number){
      const dialogRef = this.dialog.open(InterventionsDialogComponent, {
        data: {
          type: type, 
          record: record,
          doctor: this.doctorList,
          specialty: this.specialtyList,
          operationRoom: this.operationRoomList,
          patient: this.patientList,
          places: this.placesList,
          procedure: this.procedureList,
          product: this.productList,
          doctorObj: this.doctorObject,
          specialtyObj: this.specialtyObject,
          operationRoomObj: this.operationRoomObject,
          patientObj: this.patientObject,
          placesObj: this.placesObject,
          procedureObj: this.procedureObject,
          productObj: this.productObject,
          contract: this.contractList,
          customParams: this.customParams
        },
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.getEntityDataPatients();  
        this.getInterventions()
      });
    }

            /**
   * @description Ventana de dialogo para creación y edición 
   */
    openDeliveryDialog(record: any, index: number){
      const dialogRef = this.dialog.open(InterventionsDeliveryDialogComponent, {
        data: {
          record: record,
          doctor: this.doctorObject,
          operationRoom: this.operationRoomObject,
          patient: this.patientObject,
          places: this.placesList,
          placesObject: this.placesObject,
          procedure: this.procedureObject,
          kit: this.kitList,
          kitObject: this.kitObject,
          product: this.productList,
          productObject: this.productObject,
          specialty: this.specialtyObject,
          warehouses: this.warehousesList,
          warehousesObject: this.warehousesObject,
          contract: this.contractList,
          customParams: this.customParams
        },
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.getInterventions();
      });
    }
  
    /**
     * @description Ventana de dialogo de consumos
     */
    openConsumptionDialog(record: any, index: number){
      const dialogRef = this.dialog.open(InterventionsConsumptionDialogComponent, {
        data: {
          record: record,
          doctor: this.doctorObject,
          patient: this.patientObject,
          procedure: this.procedureObject,
          specialty: this.specialtyObject,
          product: this.productList,
          productObject: this.productObject,
          places: this.placesList,
          placesObject: this.placesObject,
          warehouses: this.warehousesList,
          warehousesObject: this.warehousesObject,
          contract: this.contractList,
          medicalSupplySpecialist : this.medicalSupplySpecialistList,
          technicalSpecialist : this.technicalSpecialistList,
          supplier : this.supplierList,
          users : this.usersObject,
          customParams: this.customParams
        },
      });
  
      dialogRef.afterClosed().subscribe(async result => {
        if(result) {
          this.getInterventions()
        }
      });
    }


  /**
   * @description show cancel reason 
   */
  openCancelDialog(record: any, index: number) {
    if (this.isClosedFolio(record)) return;
    const dialogRef = this.dialog.open(CancelDialog, {
      data: {
        record: record,
        doctor: this.doctorObject,
        procedure: this.procedureObject,
        specialty: this.specialtyObject,
        customParams: this.customParams
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.getInterventions()
    });
  }

  /**
   * @description show order
   */
    openOrderDialog(record: any, index: number) {
        const dialogRef = this.dialog.open(OrderDialog, {
          data: {
            record: record,
            doctor: this.doctorObject,
            specialty: this.specialtyObject,
            patient: this.patientObject,
            procedure: this.procedureObject,
            contract: this.contractList,
            customParams: this.customParams
          },
        });
      dialogRef.afterClosed().subscribe((data) => {
        if (data.clicked === 'prevale') {
          let info = record
          info['order'] = info['order']?.filter(element => element['status'] !== false) || [];
          info['doctor'] = this.doctorObject[info['doctor']];
          info['procedure'] = this.procedureObject[info['procedure']];
          info['specialty'] = this.specialtyObject[info['specialty']];
          info['products'] = this.productList;
          info['substituteList'] = this.substitutesList;
          //this.interventionsPdfService.downloadPrePDF(info);
          this.getInterventions()
        }
        else if (data.clicked === 'order') {
          let info = record
          info['order'] = info['order']?.filter(element => element['status'] !== false) || [];
          info['doctor'] = this.doctorObject[info['doctor']];
          info['procedure'] = this.procedureObject[info['procedure']];
          info['specialty'] = this.specialtyObject[info['specialty']];
          info['products'] = this.productList;
          //this.interventionsPdfService.downloadOrderPDF(info);
          this.getInterventions()
        }
      });
    }

 

  private applyAlphabeticSorting(data, key) {

 

    // Por nombre: alias primero (si el catálogo lo tiene), luego nombre/código.

 

    if (key === 'name') return sortCatalog(data ?? []);
  const sortedData = [...data];

  const normalize = (str: string) =>
    str
      ?.toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // quitar acentos
      .replace(/\s+/g, " ") // colapsar espacios múltiples
      .trim()
      .toLowerCase() ?? "";

  sortedData.sort((a, b) => {
    const valueA = normalize(a?.[key] as string);
    const valueB = normalize(b?.[key] as string);

    if (!valueA && !valueB) return 0;
    if (!valueA) return 1;
    if (!valueB) return -1;

    const numA = parseInt(valueA, 10);
    const numB = parseInt(valueB, 10);

    // Si ambos tienen número inicial válido y son distintos
    if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {
      return numA - numB;
    }

    // Si uno tiene número y el otro no
    if (!isNaN(numA) && isNaN(numB)) return -1;
    if (isNaN(numA) && !isNaN(numB)) return 1;

    // Comparar el resto del texto sin el número inicial
    const textA = valueA.replace(/^\d+\s*/, "");
    const textB = valueB.replace(/^\d+\s*/, "");

    return textA.localeCompare(textB, "es", {
      sensitivity: "base",
      ignorePunctuation: true
    });
  });

  return sortedData;
}
}



